<template>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { notify } from '../utils/notifications'

export default {
	computed: {
		...mapState({
			notifications: ({ notifications }) => notifications.notifications
		})
	},
	methods: {
		...mapMutations({
			clear: 'notifications/clearNotify'
		})
	},
	watch: {
		notifications(val) {
			if (val.length === 0) return false
			val.map(item => {
				this.$notify({ ...notify, text: this.$t(`notifications.${item}`) })
			})
			this.clear()
		}
	}
}
</script>
